import { LuvImage, UniversalCta } from '@/components';
import { TypeUgcGridFields } from '@/core/generated-types';
import React, { FC, useMemo } from 'react';
import { getImageGridPosition } from './utils';
import { useIsDesktop } from '@/hooks/useIsDesktop';

// Module that has images as a grid
const UgcGrid: FC<TypeUgcGridFields> = ({ title, subtitle, media, cta }) => {
  const isDesktop = useIsDesktop();

  const images = useMemo(() => {
    if (isDesktop) return media;

    // In mobile, we just want to show first 5 images
    return media?.slice(0, 5);
  }, [isDesktop, media]);

  if (!media) return null;

  return (
    <div className="bg-off-white">
      <div className="max-w-[1220px] text-center mx-auto p-6 pb-10 font-bold md:pt-24 md:pb-16">
        <p className="text-lg uppercase md:text-xl">{title}</p>
        <p className="text-[32px] leading-10 md:text-[40px] md:mt-10">
          {subtitle}
        </p>

        <div className="mt-5 md:mt-14">
          <div className="grid gap-3 md:grid-template-columns: repeat(4, 1fr) md:gap-6">
            {images?.map((image, index) => {
              return (
                <div
                  key={image.sys.id}
                  style={{ ...getImageGridPosition(index, isDesktop) }}
                >
                  <LuvImage
                    Image={image}
                    className="w-full h-full rounded-md"
                  />
                </div>
              );
            })}
          </div>

          {cta && (
            <div className="flex justify-center">
              <UniversalCta
                link={cta}
                defaultButtonStyle="Primary"
                className="w-full mt-6 h-14 md:mt-16 md:max-w-[261px] md:h-[62px]"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UgcGrid;
